export class ChargeCatErrorStateModel {
  categoryDeltaError: string;

  static getDefaults() {
    return {
      categoryDeltaError: null
    };
  }
}
